import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Spinner',
  props: ['specialClass'],
  components: {
    FontAwesomeIcon
  }
}



// WEBPACK FOOTER //
// ./src/components/Spinner/script.js